/***
 *
 *   USER
 *   shows the current user
 *   if user belongs to more than one account they can switch accounts here
 *
 **********/

import React from "react";
import LogoColor from "../logo/images/SDP-logo.svg";
import LogoRio from "../logo/images/Logo-RIO.svg";
import LogoColor2 from "../logo/images/Logo-RIO.png";
import Style from "./user.module.scss";

export function User(props) {
  return (
    <div className={Style.user}>
      <div className={Style.logos}>
        <img src={LogoRio} alt='Logo' width={"10%"} />
        <img src={LogoColor2} alt='Logo' width={"50%"} />
      </div>
    </div>
  );
}
